import { render, staticRenderFns } from "./GradeConversionsSelectbox.vue?vue&type=template&id=195a62fc&"
import script from "./GradeConversionsSelectbox.vue?vue&type=script&lang=js&"
export * from "./GradeConversionsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports